var defaultImageUrl;
var defaultShadeName;
var defaultPriceHtml;
var currentSelectionAvailability;

/**
* Changes the main image of a product tile to the default image when a swatch is changed.
* @param {Element} currentSwatch - The currently selected swatch element.
* @returns {void}
*/
function onChangeToDefault(currentSwatch) {
    const $productTile = $(currentSwatch).closest('.product-tile');
    $productTile.find('.tile-image').attr('src', defaultImageUrl);
    $productTile.find('.js-tile-shade-name').text(defaultShadeName);
    if (defaultPriceHtml) {
        $productTile.find('.price').html(defaultPriceHtml);
    }

    const $product = $(currentSwatch).closest('.product');
    const selectedSwatch = $product.find('.swatch-link.selected').find('.swatch');
    if (selectedSwatch.data('isdiscontinued')) {
        currentSelectionAvailability = 'js-discontinued';
    } else if (selectedSwatch.data('availability')) {
        currentSelectionAvailability = 'js-add-to-bag';
    } else {
        currentSelectionAvailability = 'js-out-of-stock';
    }
    $product.find('.js-add-to-bag-btn').addClass('d-none');
    $product.find(`.js-add-to-bag-btn[data-addtobag="${currentSelectionAvailability}"]`).removeClass('d-none');
    $productTile.find('a.image-link').attr('href', $(selectedSwatch).data('pdpurl'));
    $productTile.find('.pdp-link .link').attr('href', $(selectedSwatch).data('pdpurl'));
}

/**
* Handles the color change event for product swatches.
* @returns {void}
*/
function handleColorChange() {
    $('.product-tile').on('mouseenter click', '.color-swatches .swatch-link', function (e) {
        e.preventDefault();
        const $currentSwatch = $(this);
        const $tile = $currentSwatch.closest('.product-tile');
        const $product = $currentSwatch.closest('.product');

        const $mainImage = $tile.find('.tile-image');
        const $shadeName = $tile.find('.js-tile-shade-name');
        const $shadePrice = $tile.find('.price');
        const $uvpLabel = $shadePrice.find('.uvp-label');
        const $addToBagContainer = $product.find('.js-add-to-bag-container');
        const $swatchImage = $currentSwatch.find('.swatch');

        const swatchImageUrl = $swatchImage.data('product-img');
        const currentShadeName = $swatchImage.data('shadename');
        const currentShadePrice = $swatchImage.data('price');
        const currentListPrice = $swatchImage.data('list-price');
        const isAvailable = $swatchImage.data('availability');
        const isDiscontinued = $swatchImage.data('isdiscontinued');

        defaultImageUrl = $mainImage.attr('src');
        defaultShadeName = $shadeName.attr('data-shadename-default');
        defaultPriceHtml = $shadePrice.html();

        if (swatchImageUrl) {
            $mainImage.attr('src', swatchImageUrl);
            $mainImage.attr('href', $(this).attr('href'));
        }

        $shadeName.text(currentShadeName);
        if (currentShadePrice) {
            var strikeHtml = currentListPrice ? "<del class='del-price'><span class='strike-through list'><span class='value'>" + currentListPrice + "</span></span></del>" : '';
            var currentPriceHtml;
            if ($uvpLabel.length !== 0) {
                currentPriceHtml = "<span class='range'><span class='sales'><span class='uvp-label'>" + $uvpLabel.text() + "</span><span class='value'>" + currentShadePrice + "</span></span>" + strikeHtml + "</span>";
            } else {
                currentPriceHtml = "<span class='range'><span class='sales'><span class='value'>" + currentShadePrice + "</span></span>" + strikeHtml + "</span>";
            }
            $shadePrice.empty().append(currentPriceHtml);
        }

        if (isDiscontinued) {
            // Hide both Add to Bag and Out of Stock, show discontinued message (if any)
            $addToBagContainer.find('.js-add-to-bag').addClass('d-none');
            $addToBagContainer.find('.js-out-of-stock').addClass('d-none');
            $addToBagContainer.find('.js-discontinued').removeClass('d-none');
        } else if (isAvailable) {
            $addToBagContainer.find('.js-add-to-bag').removeClass('d-none');
            $addToBagContainer.find('.js-out-of-stock').addClass('d-none');
            $addToBagContainer.find('.js-discontinued').addClass('d-none');
        } else {
            $addToBagContainer.find('.js-add-to-bag').addClass('d-none');
            $addToBagContainer.find('.js-out-of-stock').removeClass('d-none');
            $addToBagContainer.find('.js-discontinued').addClass('d-none');
        }

        var variantId = $swatchImage.data('variant-id');
        if (variantId !== undefined && variantId !== null) {
            $addToBagContainer.find('.js-add-to-bag').data('pid', variantId);
        }

        if (e.type === 'click') {
            $shadeName.attr('data-shadename-default', currentShadeName);
            defaultShadeName = currentShadeName;
            defaultPriceHtml = $shadePrice.html();
            $swatchImage.closest('.swatches').find('.swatch-link').removeClass('selected');
            $swatchImage.closest('.swatches').find('.swatch-link').attr('aria-checked', 'false');
            $currentSwatch.addClass('selected');
            $currentSwatch.attr('aria-checked', 'true');
            if (variantId) {
                const $productTile = $(this).closest('.product-tile');
                var url = $currentSwatch.closest('.color-swatches').data('wishlist-url');
                $productTile.find('.swatch-link').removeClass('swatch-active');
                $(this).addClass('swatch-active');
                const $wishlistTile = $currentSwatch.closest('.product').find('.wishlistTile');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: { pid: variantId },
                    success: function (data) {
                        if (data.isInWishlist) {
                            $wishlistTile.addClass('active');
                        } else {
                            $wishlistTile.removeClass('active');
                        }
                    }
                });
            }
        }

        $currentSwatch.on('mouseleave', function () {
            onChangeToDefault(this);
        });
    });

    $('.product-tile').on('keydown', '.color-swatches .swatch-link', function (e) {
        var keys = {
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            HOME: 36,
            END: 35,
            ENTER: 13,
            SPACE: 32
        };
        var code = e.which || e.keyCode;
        if (
            [
                keys.LEFT,
                keys.UP,
                keys.RIGHT,
                keys.DOWN,
                keys.HOME,
                keys.END,
                keys.ENTER,
                keys.SPACE
            ].indexOf(code) === -1
        ) {
            return;
        }
        e.preventDefault();

        var $current = $(this);
        const $group = $current.closest('[data-attr="color"]');
        const $radios = $group.find('[role="radio"]');
        const $enabled = $radios.filter(
            ':not(:disabled)[aria-disabled!="true"]'
        );

        // Index within enabled list (fallback to first enabled)
        let idxEnabled = $enabled.index($current);
        if (idxEnabled === -1) {
            idxEnabled = $enabled.index(
                $enabled.filter('[aria-checked="true"]').first()
            );
            if (idxEnabled === -1) idxEnabled = 0;
        }

        /**
         * Moves focus to the given radio element and updates tabindex.
         * @param {jQuery} $t - The target radio element.
         * @returns {undefined}
         */
        function moveTo($t) {
            if (!$t || !$t.length) return undefined;
            $radios.attr('tabindex', '-1');
            $t.attr('tabindex', '0').focus();
            return undefined;
        }

        if (code === keys.HOME) {
            moveTo($enabled.first());
            return;
        }
        if (code === keys.END) {
            moveTo($enabled.last());
            return;
        }
        if (code === keys.LEFT || code === keys.UP)
            moveTo($enabled.eq(Math.max(idxEnabled - 1, 0)));
        if (code === keys.RIGHT || code === keys.DOWN)
            moveTo(
                $enabled.eq(Math.min(idxEnabled + 1, $enabled.length - 1))
            );
        if (
            (code === keys.ENTER || code === keys.SPACE) &&
            !$current.attr('disabled')
        )
            $current.click();

        if (
            (code === keys.ENTER || code === keys.SPACE) &&
            !$current.attr('disabled')
        ) {
            $current.click();
        }
    });
}

module.exports = {
    handleColorChange: function () {
        handleColorChange();
        $('body').on('init:handleColorChange', handleColorChange);
    }
};
